export default __webpack_public_path__ + "static/media/640_portfolio04-fr-mobile.23caaf09.png";